interface ErrorCode {
    title: string;
    description: string;
    iconType: string;
  }
  
  interface ErrorCodes {
    [key: number]: ErrorCode;
    default: ErrorCode;
  }
  
  const errorCodes: ErrorCodes = {
    400: {
      title: "Bad Request",
      description:
        "An error has occurred while processing your request. We apologize for the inconvenience. Please try again.",
      iconType: "error",
    },
    401: {
      title: "Unauthenticated",
      description: "You do not have permission to access this application. ",
      iconType: "lock",
    },
    403: {
      title: "Access Denied!",
      description:
        "You do not have permission to access this application. We apologize for the inconvenience. If you believe that you have received this message in error, please contact technical support staff at...",
      iconType: "lock",
    },
    404: {
      title: "Resource not found",
      description:
        "An error has occurred while processing your request. We apologize for the inconvenience. Please try again.",
      iconType: "error",
    },
    default: {
      title: "Error has occurred",
      description:
        "An error has occurred while processing your request. We apologize for the inconvenience. Please try again.",
      iconType: "error",
    },
  };
  
  export default errorCodes;
  